<template>
  <div>
    <config-title title="Definições"></config-title>
    <update-password></update-password>
    <update-pin-enterprise></update-pin-enterprise>
    <section-delete-account></section-delete-account>
    <delete-entity></delete-entity>
    <open-change-security></open-change-security>
  </div>
</template>

<script>
import Title from "../geral/Title";
import UpdatePassword from "./config/UpdatePassword";
import SectionDeleteAccount from "./config/SectionDeleteAccount";
import OpenChangeSecurity from "./tools/OpenChangeSecurity";
import DeleteEntity from "@/components/dashboard/enterprise/config/DeleteEntity";
import UpdatePinEnterprise from "@/components/dashboard/enterprise/config/UpdatePinEnterprise";

export default {
  name: "ConfigEnterprise",
  components: {
    UpdatePinEnterprise,
    DeleteEntity,
    OpenChangeSecurity,
    SectionDeleteAccount,
    UpdatePassword,
    "config-title": Title
  }
};
</script>

<style scoped></style>
